module.exports = __webpack_public_path__ + "img/base-placeholder.2a300e87.jpg";